import { render, staticRenderFns } from "./AppPage.vue?vue&type=template&id=08e06718&scoped=true"
import script from "./AppPage.vue?vue&type=script&lang=js"
export * from "./AppPage.vue?vue&type=script&lang=js"
import style0 from "./AppPage.vue?vue&type=style&index=0&id=08e06718&prod&lang=css"
import style1 from "./AppPage.vue?vue&type=style&index=1&id=08e06718&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e06718",
  null
  
)

export default component.exports